import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { MdCheck, MdOutlineCheckCircle, MdOutlineCircle, MdOutlineCopyAll } from "react-icons/md";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const PERMISSIONS = [
    {
        id: "read",
        name: "Read"
    },
    {
        id: "write",
        name: "Read and write"
    }
];

const NewApiKeyModal = ({ account_id, show, handleClose, fetchRecords }) => {
    const { t } = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [secret, setSecret] = useState(null)
    const [checkCopy, setCheckCopy] = useState(false)

    const [formData, setFormData] = useState({
        name: "",
        description: "",
        permissions: "write",
        expiration: ""
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handlePermissionSelect = (id) => {
        setFormData(prev => ({
            ...prev,
            permissions: id
        }));
    };

    const handleSave = async () => {
        if (!formData.name.trim()) {
            setErrorMessage({ message: t.api_keys.name_required, display: true });
            return;
        }

        if (!formData.description.trim()) {
            setErrorMessage({ message: t.api_keys.desc_required, display: true });
            return;
        }

        // if (!formData.permissions) {
        //     setErrorMessage({ message: "Please select a permission", display: true });
        //     return;
        // }

        if (!formData.expiration) {
            setErrorMessage({ message: t.api_keys.exp_date_mex, display: true });
            return;
        }

        const today = new Date().toISOString().split("T")[0];

        if (formData.expiration < today) {
            setErrorMessage({
                message: t.api_keys.expired_date_msg,
                display: true
            });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/create_api_key`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id: account_id,
                    name: formData.name,
                    description: formData.description,
                    permission: formData.permissions,
                    expiration: formData.expiration
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                setSecret(data.api_key)
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        handleClose();
        setFormData({ name: "", description: "", permissions: "write" });
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
        setSecret(null)
        secret && fetchRecords()
    };

    const selectedPermissionLabel = PERMISSIONS.find(p => p.id === formData.permissions)?.name;

    const copyItem = (item) => {
        navigator.clipboard.writeText(item)
            .then(() => {
                setCheckCopy(true);
                setTimeout(() => {
                    setCheckCopy(false);
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.api_keys.new_item}</p>
            </div>

            <div className="modal_main_cont">
                {secret ? (
                    <div className="modal_profile_input_cont">
                        <div className="label_input">
                            <label className="input_label">{t.api_keys.api_key}</label>
                            <p className="register_form_first register_form_first_disabled fade-in" onClick={() => copyItem(secret)}><span className="form_strings">{secret}</span> {checkCopy ? <i className="fade-in"> <MdCheck /></i> : <i className="fade-in"><MdOutlineCopyAll /></i>}</p>
                            <p className="modal_info_p">
                                {t.api_keys.api_warning}
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="modal_profile_input_cont">
                        <div className="label_input">
                            <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                            <input
                                type="text"
                                name="name"
                                maxLength={100}
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="EX - Weather"
                                className="register_form_first fade-in"
                                autoComplete="off"
                            />
                        </div>

                        <div className="label_input">
                            <label className="input_label">
                                {t.description} <MandatorySign message={t.mandatory_field} />
                            </label>
                            <textarea
                                name="description"
                                maxLength={300}
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="EX - Weather app api-key"
                                className="register_form_first textarea_reg fade-in"
                                autoComplete="off"
                            />
                        </div>

                        {/* <div className="label_input">
                            <label className="input_label">Permissions <MandatorySign message={"Permission is required"} /></label>
                            <Dropdown>
                                <Dropdown.Toggle
                                    as="div"
                                    className="register_form_first fade-in d-flex justify-content-between align-items-center"
                                    style={{ cursor: 'pointer' }}
                                >
                                    {selectedPermissionLabel || "Select permission"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="custom_dropdown_menu">
                                    <div className="dropdown_container fade-in">
                                        {PERMISSIONS.map((permission) => (
                                            <button
                                                key={permission.id}
                                                onClick={() => handlePermissionSelect(permission.id)}
                                                className="settings_link"
                                                type="button"
                                            >
                                                <i className="me-2">
                                                    {formData.permissions === permission.id
                                                        ? <MdOutlineCheckCircle />
                                                        : <MdOutlineCircle />}
                                                </i>
                                                {permission.name}
                                            </button>
                                        ))}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div> */}

                        <div className="label_input">
                            <label className="input_label">{t.api_keys.exp_date} <MandatorySign message={t.mandatory_field} /></label>
                            <input
                                type="date"
                                name="expiration"
                                value={formData.expiration}
                                onChange={handleChange}
                                className="register_form_first fade-in"
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    {!secret && (
                        <button
                            className="modale_save_btn"
                            onClick={handleSave}
                            disabled={loadingSave}
                        >
                            {loadingSave ? <Spinner loading={true} /> : t.save}
                        </button>
                    )}

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewApiKeyModal;